import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IrisButtonContainerComponent } from './button-container/button-container.component';
import { IrisButtonComponent } from './button.component';

@NgModule({
  declarations: [
    IrisButtonComponent,
    IrisButtonContainerComponent
  ],
  imports: [CommonModule],
  exports: [
    IrisButtonComponent,
    IrisButtonContainerComponent
  ],
})
export class IrisButtonModule {}
